import { render, staticRenderFns } from "./viewBrand.vue?vue&type=template&id=50bd7793&"
import script from "./viewBrand.vue?vue&type=script&lang=js&"
export * from "./viewBrand.vue?vue&type=script&lang=js&"
import style0 from "./viewBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports